import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { Icon } from '../icon/icon';
import { numericInputControlIcon, numericInputControlIconIncrSmall, numericInputControlIconDecrSmall } from './control-icon';
import * as classnames from 'classnames';
var NumericInput = /** @class */ (function (_super) {
    __extends(NumericInput, _super);
    function NumericInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputElement = null;
        _this.onInputChange = function (e) {
            var _a = _this.props, max = _a.max, min = _a.min, steps = _a.steps;
            var valueAsString = e.target.value;
            var maybeValueAsNumber = !steps ? parseInt(valueAsString, 10) : Number(Number(valueAsString).toFixed(2));
            if (valueAsString === '') {
                _this.props.onChange(null);
            }
            else if (!isNaN(maybeValueAsNumber)) {
                var newValueAsNumber = (min && maybeValueAsNumber <= min) ? min : (max && maybeValueAsNumber >= max) ? max :
                    (steps && maybeValueAsNumber % steps) ? Math.round(maybeValueAsNumber / steps) * steps : maybeValueAsNumber;
                if (valueAsString.length > 1 &&
                    valueAsString.charAt(0) === '0' && valueAsString.charAt(1) !== '.' && _this.inputElement) {
                    _this.inputElement.value = "" + newValueAsNumber;
                }
                _this.props.onChange(newValueAsNumber);
            }
        };
        _this.onIncrement = function (e) {
            var _a = _this.props, steps = _a.steps, max = _a.max;
            e.preventDefault();
            var currentValue = _this.props.value;
            var newValue = Number(currentValue) + (steps ? steps : 1);
            var maybeMaxNewValue = (max && newValue >= max) ? max : newValue;
            _this.props.onChange(maybeMaxNewValue);
            if (_this.inputElement) {
                _this.inputElement.focus();
            }
        };
        _this.onDecrement = function (e) {
            var _a = _this.props, steps = _a.steps, min = _a.min;
            e.preventDefault();
            var currentValue = _this.props.value;
            var newValue = Number(currentValue) - (steps ? steps : 1);
            var maybeMinNewValue = (min && newValue <= min) ? min : newValue;
            _this.props.onChange(maybeMinNewValue);
            if (_this.inputElement) {
                _this.inputElement.focus();
            }
        };
        _this.setInputElement = function (elem) {
            _this.inputElement = elem;
        };
        // solution for bug in safari and firefox (entered non-digits are visible)
        _this.checkIfNaN = function (e) {
            var _a;
            var currentValue = (_a = _this.props.value) === null || _a === void 0 ? void 0 : _a.toString();
            var maybeFirstDecimal = !!_this.props.steps && (e.key === '.') && (currentValue === null || currentValue === void 0 ? void 0 : currentValue.indexOf('.')) === -1;
            var maybeNegativeNumber = !(currentValue === null || currentValue === void 0 ? void 0 : currentValue.length) && e.key === '-';
            if (isNaN(Number(e.key)) && !maybeFirstDecimal && !maybeNegativeNumber) {
                e.preventDefault();
            }
        };
        return _this;
    }
    NumericInput.prototype.render = function () {
        var props = this.props;
        var classNames = namespacedClassnames('numeric-input', { small: props.size === 'small' });
        var spinButtonsClassNames = classnames('spin-buttons', props.disabled ? 'disabled' : '');
        var incrementIcon = props.size === 'small' ? numericInputControlIconIncrSmall : numericInputControlIcon;
        var decrementIcon = props.size === 'small' ? numericInputControlIconDecrSmall : numericInputControlIcon;
        var value = props.value === null ? '' : props.steps ? Number(props.value.toFixed(2)) : props.value;
        var isMax = !!props.max && value >= props.max;
        var isMin = !!props.min && value <= props.min;
        var incrementSpinButton = (React.createElement("button", { className: classnames('spin', 'increment', { max: isMax }), "aria-label": 'increment', onClick: this.onIncrement, disabled: props.disabled || isMax },
            React.createElement(Icon, { icon: incrementIcon })));
        var decrementSpinButton = (React.createElement("button", { className: classnames('spin', 'decrement', { min: isMin }), "aria-label": 'decrement', onClick: this.onDecrement, disabled: props.disabled || isMin },
            React.createElement(Icon, { icon: decrementIcon })));
        return (React.createElement("span", { className: classNames },
            React.createElement("input", { type: 'number', placeholder: props.placeholder, value: value, onChange: this.onInputChange, disabled: props.disabled, ref: this.setInputElement, step: this.props.steps, onKeyPress: this.checkIfNaN }),
            React.createElement("div", { className: spinButtonsClassNames },
                incrementSpinButton,
                decrementSpinButton)));
    };
    return NumericInput;
}(React.Component));
export { NumericInput };
//# sourceMappingURL=numeric-input.js.map